export default {
  "students.billing.isento": "Isento de Mensalidade",
  "students.billing.isento_with_count": "Isento de Mensalidade ({{count}})",
  "students.billing.generate": "Gerar Mensalidades",
  "students.billing.installments_one": "1 Parcela Gerada",
  "students.billing.installments_many": "{{count}} Parcelas Geradas"
};